import { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Benefits from "@/components/Benefits";
import Steps from "@/components/Steps";
import Stories from "@/components/Stories";
import Pricing from "@/components/Pricing";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import DownloadModal from "@/components/DownloadModal";
import Referral from "@/pages/Referral";
import Invite from "@/pages/Invite";
import LegalPage from "@/pages/Legal";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default function App() {
  const [trialOpen, setTrialOpen] = useState(false);
  const openTrial = useCallback(() => setTrialOpen(true), []);
  const closeTrial = useCallback(() => setTrialOpen(false), []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen overflow-x-clip bg-nora-bg font-sans text-nora-ink antialiased">
        <Header onCta={openTrial} />
        <Routes>
          <Route
            path="/"
            element={
              <main>
                <Hero onCta={openTrial} />
                <Marquee />
                <Benefits />
                <Steps />
                <Stories />
                <Pricing onCta={openTrial} />
                <Faq />
                <FinalCta onCta={openTrial} />
              </main>
            }
          />
          <Route path="/referral" element={<Referral onCta={openTrial} />} />
          <Route path="/invite/:code?" element={<Invite />} />
          <Route path="/privacy" element={<LegalPage page="privacy" />} />
          <Route path="/terms" element={<LegalPage page="terms" />} />
          <Route path="/support" element={<LegalPage page="support" />} />
          <Route
            path="/delete-account"
            element={<LegalPage page="delete-account" />}
          />
        </Routes>
        <Footer />
        <DownloadModal open={trialOpen} onClose={closeTrial} />
      </div>
    </BrowserRouter>
  );
}
